<template>
  <div class="animated fadeIn">
    <b-row class="mt-4">
      <b-col md="9">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text class="standardizedWidth"
                >Cluster Name</b-input-group-text
              >
            </b-input-group-prepend>
            <b-form-input
              v-model.lazy="current_rotation.RotationName"
              placeholder="Name"
              type="text"
              autocomplete="off"
              id="RotationName"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="2">
        <i
          v-b-tooltip
          title="Delete Cluster"
          class="fa fa-trash fa-lg mt-2 pt-1 float-right clickIcon"
          @click="deleteRotation"
        ></i>
        <i
          v-b-tooltip
          title="Map Cluster"
          class="fa fa-globe fa-lg mt-2 pt-1 mr-3 float-right clickIcon"
          @click="mapRotation"
        ></i>
        <i
          v-b-tooltip
          title="Download Zips"
          class="fa fa-download fa-lg mt-2 pt-1 mr-3 float-right clickIcon"
          style="color: #000;"
          @click="my_rotation_download"
        ></i>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="4">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text class="standardizedWidth"
                >Color: {{ current_rotation.RotationColor }}</b-input-group-text
              >
            </b-input-group-prepend>
            <b-form-input
              v-bind:style="{
                backgroundColor: current_rotation.RotationColor,
                color: current_rotation.RotationColor
              }"
              v-model="current_rotation.RotationColor"
              autocomplete="off"
              type="text"
              id="RotationColor"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="8" class="mb-5">
        <!-- <slider v-model="activeColor2"></slider> -->
        <chrome v-model="activeColor2"></chrome>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="2" class="text-left">
        <span class="icon-small">
          <i
            v-if="!show"
            class="fa fa-plus-circle fa-lg mt-0 pt-0 mr-2 clickIcon"
            style="color: #555"
            @click="show = !show"
          ></i>
          <i
            v-if="show"
            class="fa fa-minus-circle fa-lg mt-0 pt-0 mr-2 clickIcon"
            style="color: #555"
            @click="show = !show"
          ></i>
          <span class="tabtext">Zips:</span>
        </span>
      </b-col>
      <b-col md="8" class="mb-5">
        <RotationZipContainer v-if="show" :rotation_object="current_rotation" />
      </b-col>
    </b-row>

    <hr />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { Slider, Chrome } from "vue-color";
import RotationZipContainer from "@/components/CustomSubComponents/RotationZipContainer.vue";
//import StyledDialog from "@/components/dialogs/StyledModal.vue";
//import { required, email, helpers } from "vuelidate/lib/validators";
//const alpha = helpers.regex("alpha", /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/);
//import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";

export default {
  name: "RotationRow",
  components: {
    Slider,
    Chrome,
    RotationZipContainer
  },
  props: {
    rotation_object: { type: Object },
    territory_object: { type: Object }
  },
  data() {
    return {
      current_rotation: this.rotation_object,
      current_territory: this.territory_object,
      selected: [], // Must be an array reference!
      dirtyFields: [],
      show: true,
      seen: true,
      isSaving: false,
      isSaved: false,
      dismissSecs: 3,
      dismissCountDown: 0,
      dismiss2Secs: 3,
      dismiss2CountDown: 0,
      showDismissibleAlert: false,
      activeColor2: {},
      timer: null
    };
  },
  methods: {
    my_rotation_download() {
      this.$store
        .dispatch("territory/DownloadRotationZips", this.current_rotation)
        .then(response =>
          window.open(
            "http://rm_api.revolutionterritorymanager.com/Output/" +
              response.data["ExportRotationZipsResult"],
            "_blank"
          )
        );
    },
    back() {
      this.$router.go(-1);
    },
    // deleteRotaton() {
    //   this.$emit("DeleteRotation", this.current_rotation);
    // },
    deleteRotation() {
      this.$emit("DeleteRotation", this.current_rotation);
    },
    mapRotation() {
      this.$store
        .dispatch(
          "territory/loadRotationEdit",
          this.current_rotation.RotationID
        )
        .then(() => {
          this.$router.push("/rotation-check-maps");
          //,
          //params: { id: this.event.id }
        })
        .catch(() => {
          console.log("There was a problem");
          //.dispatch('notification/add', this.event)
        });
    },
    toggleVisibility() {
      this.seen = !this.seen;
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    countDown2Changed(dismiss2CountDown) {
      this.dismiss2CountDown = dismiss2CountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    save() {
      this.$v.$touch();
      if (this.$v.$error) {
        this.dismiss2CountDown = this.dismiss2Secs;
      } else {
        this.$store
          .dispatch("saveOp/BuildSaveOperation")
          .then(
            this.$store
              .dispatch("saveOp/EmitSave")
              .then(
                (this.dirtyFields = [])(
                  (this.dismissCountDown = this.dismissSecs)
                )(this.$store.state.saveOp.DestroySaveOperation)
              )
          );
      }
    },
    saveField: function(event) {
      //alert(this.current_rotation.RotationID)
      var _operation = {
        TerritoryID: this.current_territory.TerritoryID,
        RotationID: this.current_rotation.RotationID,
        FieldToSet: event.target.id,
        ValueToSet: event.target.value
      };

      this.$store.dispatch("territory/SaveRotation", _operation).then();
    },
    addDirtyField: function(event) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== event.target.id
      );
      this.dirtyFields.push({
        FieldName: event.target.id,
        FieldValue: event.target.value
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    addDirtyFieldWatch: function(field, newValue) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== field
      );
      this.dirtyFields.push({
        FieldName: field,
        FieldValue: newValue
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    addDirtyFieldSwitch: function(event) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== event.target.id
      );
      this.dirtyFields.push({
        FieldName: event.target.id,
        FieldValue: event.target.checked.toString()
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    }
  },
  computed: {
    ...mapState(["seminar", "territory", "zip", "n_user"]),
    ...mapActions("saveOp", ["Save", "EmitSave"]),
    isClean() {
      return this.dirtyFields.length === 0;
    }
  },
  created() {
    this.activeColor2.hex = this.current_rotation.RotationColor;
    //console.log(this.activeColor2);
    //this.activeColor2.hex = this.current_rotation.RotationColor;
    if (this.current_rotation.RotationID === -1) {
      this.$store
        .dispatch("territory/addRotation", this.current_rotation)
        .then(response => {
          this.current_rotation.RotationID = response.data["AddRotationResult"];
          //console.log(response);
        });
    }
  },
  watch: {
    "current_rotation.RotationName": function() {
      var _event = {
        target: {
          id: "RotationName",
          value: this.current_rotation.RotationName
        }
      };
      this.saveField(_event);
    },
    activeColor2: function(newValue, oldValue) {
      if (this.timer) {
        window.clearTimeout(this.timer);
      }
      this.timer = window.setTimeout(() => {
        this.timer = null;
        this.current_rotation.RotationColor = newValue.hex;
        var _check_color = this.$store.state.zip.rotation_zip_symbols.find(
          rzs => rzs.RotationID === this.current_rotation.RotationID
        );
        if (_check_color) {
          this.$store.state.zip.rotation_zip_symbols.find(
            rzs => rzs.RotationID === this.current_rotation.RotationID
          ).SymbolColor = newValue.hex;
        }
        var _event = {
          target: {
            id: "RotationColor",
            value: newValue.hex
          }
        };
        this.saveField(_event);
      }, 1000);
    }
  },
  mounted() {}
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.input-group-text {
  color: #111;
}
hr {
  border: none;
  border-top: 1px dotted #333;
  color: #fff;
  background-color: #fff;
  height: 1px;
  width: 100%;
}
</style>
